<template>
	<div class="modal fade" id="MdServicos">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Serviços</h4>
				</div>
				<div class="modal-body">
					<!-- <ul class="nav nav-tabs">
						<li :class="cmponent == 0 ? 'active' : ''"><a @click='cmponent = 0'>Configurações</a></li>
						<li :class="cmponent == 1 ? 'active' : ''"><a @click='cmponent = 1'>Tarefas</a></li>
					</ul>	 -->

					<SettingsServices :dIn="data" />
					<br />
					<VinculoTarefas :dIn="data" :assets="assets" />

					<div class="clearfix"></div>
					<br />
				</div>
				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-default"
						data-dismiss="modal"
					>
						<i class="fa fa-close"></i>
						Cancelar
					</button>
					<button type="button" class="btn btn-primary" @click="save">
						<i class="fa fa-save"></i>
						Salvar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import SettingsServices from './configuracoes.vue';
	import VinculoTarefas from './vincTarefas.vue';
	import toastr from 'toastr';
	import WBS from 'js/http';
	import clone from 'js/clone';
	let reset = {
		cod: null,
		servico: '',
		sigla: '',
		duracao: '',
		valor: '',
		tipo_servico: 'c',
		interno: 's',
		tarefas: [],
		cat: '',
	};

	export default {
		name: 'MdServicos',
		components: { SettingsServices, VinculoTarefas },
		props: ['assets'],
		data() {
			return {
				cmponent: 0,
				data: clone(reset),
			};
		},
		methods: {
			open(data = null) {
				if (data == null) this.data = clone(reset);
				else this.data = clone(data);
				$('#MdServicos').modal('show');
			},
			save() {
				let sData = clone(this.data);
				sData.cat = this.$route.params.id;

				// Montando caches ......................
				let cacheDeptos = [];
				let cacheForms = [];
				sData.tarefas.forEach((item) => {
					if (item.deptos != undefined && item.deptos.join('|') != '')
						cacheDeptos.push(item.deptos.join('|'));
					if (item.forms != undefined && item.forms.join('|') != '')
						cacheForms.push(item.forms.join('|'));
				});

				sData.cache_deptos = `|${cacheDeptos.join('|')}|`;
				sData.cache_forms = `|${cacheForms.join('|')}|`;

				// console.log(sData)
				WBS.send('private-save-services', sData, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Serviço salvo com sucesso!');
						this.$emit('update');
						$('#MdServicos').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>
<style scoped>
	.nav li a {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/services/modal.vue